/* eslint-disable */

/** unique or primary key constraints on table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingConstraint {
  /** unique or primary key constraint on columns "material_model_attribute_setting_id" */
  MaterialModelAttributeSettingPkey = 'material_model_attribute_setting_pkey'
}

/** select columns of table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_model_attribute_setting" */
export enum ArgoMaterialModelAttributeSettingUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialModelId = 'material_model_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

